
import MatrixInputItemRow from "./MatrixInputItemRow";

const MatrixInputDesktopInterface = props => {
  const {
    fieldName,
    items,
    options,
    isChecked,
    onChange,
    maximumSelectableOptions,
    singleOptionSelection
  } = props;

  return (
    <table className="table table-striped table-hover table-matrix">
      <thead>
        <tr className="matrix-input-header-row">
          <th></th>
          {options.map(option => (
            <th key={option.id}>{option.name}</th>
          ))}
        </tr>
      </thead>

      <tbody>
        {items.map(item => (
          <MatrixInputItemRow
            key={item.id}
            item={item}
            fieldName={fieldName}
            options={options}
            isChecked={isChecked}
            onChange={onChange}
            maximumSelectableOptions={maximumSelectableOptions}
            singleOptionSelection={singleOptionSelection}
          />
        ))}
      </tbody>
    </table>
  );
};

export default MatrixInputDesktopInterface;
